export const DISCLAIMER = `*כל שינוי בריבית הפריים ישפיע על גובה ההחזר/תשלום חודשי הצפוי בשנתיים הראשונות כמו גם בתקופה שאחרי.`